@if (content | translate) {
    <section class="legal-page-container" [innerHTML]="content | translate"></section>
}
@if (isNotFound) {
    <app-no-route></app-no-route>
}
